import React, { isValidElement } from "react";
export function isElementOrFragment(node) {
    return !!node && typeof node === "object" && "type" in node;
}
export function isFragment(node) {
    return isValidElement(node) && node.type === React.Fragment;
}
export function isElement(node) {
    return isValidElement(node) && node.type !== React.Fragment;
}
export default isElement;
//# sourceMappingURL=is-element.js.map